import React, { forwardRef } from 'react'
import styled from 'styled-components'

interface Props extends React.ComponentProps<'div'> {}

const PlaceholderText = forwardRef<HTMLDivElement, Props>(
  ({
    ...props
  }, ref) => {
    return (
      <CustomText
        {...props}
        ref={ref}
      />
    )
  }
)

export default PlaceholderText

const CustomText = styled.div`
  color: var(--gray-81);
  font-size: 18px;
`
